module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Teaching in Tongren, China")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgment"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-1-guizhou-province"
    }
  }, [_vm._v("Chapter 1: Guizhou Province")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-2-the-city-of-tongren"
    }
  }, [_vm._v("Chapter 2: The City of\n                    Tongren")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#introduction-1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#transport"
    }
  }, [_vm._v("2.1: Transport")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#walking-street"
    }
  }, [_vm._v("2.2: Walking Street")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#qingshui-dadao"
    }
  }, [_vm._v("2.3: Qingshui Dadao")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#jin-jing-guangcheng"
    }
  }, [_vm._v("2.4: Jin Jing Guangcheng")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#old-tongren"
    }
  }, [_vm._v("2.5: Old Tongren")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-3-accommodation"
    }
  }, [_vm._v("Chapter 3: Accommodation")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#arrival"
    }
  }, [_vm._v("3.1: Arrival")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#my-first-apartment"
    }
  }, [_vm._v("3.2: My First Apartment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#my-second-apartment"
    }
  }, [_vm._v("3.3: My Second Apartment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#the-backyard"
    }
  }, [_vm._v("3.4: The Backyard")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#how-i-blew-a-fuse"
    }
  }, [_vm._v("3.5: How I Blew a Fuse")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#other-apartments"
    }
  }, [_vm._v("3.6: Other Apartments")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#the-final-year"
    }
  }, [_vm._v("3.7: The Final Year")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-4-the-jinjiang-river",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The Jinjiang River")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#around-the-river",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1: Around the River")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#on-the-river",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2: On the River")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#in-the-river",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.3: In the River")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-5-mountains",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Mountains")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#introduction-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#wen-bi-feng",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.1: Wen Bi Feng")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#jia-nian-shan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.2: Jia Nian Shan")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#xiao-shan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.3: Xiao Shan")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#railway-hill",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.4: Railway hill")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#fan-jing-shan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.5: Fan Jing Shan")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#on-location",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.6: On Location")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-6-tongren-university",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Tongren University")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#introduction-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#tongren-university-campus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1: Tongren University\n                            campus")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#the-foreign-affairs-office",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.2: The Foreign Affairs\n                            Office")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#health-checks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.3: Health Checks")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#how-was-your-holiday",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.4: How Was Your Holiday?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#attitudes-to-laowai",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.5: Attitudes to\n                            "), _c('em', [_vm._v("Laowai")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#athletics-carnivals",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.6: Athletics Carnivals")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-7-teaching",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Teaching")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#introduction-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#classes-and-courses",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.1: Classes and Courses")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#dreams",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.2: Dreams")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#english-festival",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.3: English Festival")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#english-contests",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.4: English Contests")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#examinations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.5: Examinations")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#art",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.6: Art")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-8-the-students",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Students")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#introduction-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#names",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.1: Names")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#bai-ma-dong",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.2: Bai Ma Dong")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#cao-ping-yuan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.3: Cao Ping Yuan")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-101"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#jiu-long-dong",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.4: Jiu Long Dong")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-102"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#a-great-weekend",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.5: A Great Weekend")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-103"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#more-class-picnics",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.6: More Class Picnics")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-107"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#contests",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.7: Contests")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-108"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-9-outside-tongren",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Outside Tongren")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-109"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#introduction-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#ielts-preparation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.1: IELTS Preparation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#wan-shan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.2: Wan Shan")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-112"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#mai-cun",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.3: Mai Cun")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-113"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#kaili",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.4: Kaili")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-114"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#guiyang",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.5: Guiyang")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-115"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#the-cost-of-a-signature",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.6: The Cost of a\n                            Signature")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-116"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#sinan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.7: Sinan")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-120"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#shiqian",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.8: Shiqian")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-124"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#zhen-yuan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.9: Zhen Yuan")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-125"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#other-towns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.10: Other Towns")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-131"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-10-celebrations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Celebrations")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-132"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#christmas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.1: Christmas")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-135"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#lantern-festival",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.2: Lantern Festival")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-136"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#qing-ming",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.3: Qing Ming")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-137"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#duan-wu-jie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.4: Duan Wu Jie")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-138"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#national-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.5: National Day")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-139"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#weddings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.6: Weddings")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-142"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#concerts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.7: Concerts")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-145"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#meals",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.8: Meals")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-149"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-11-daily-living",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Daily Living")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-150"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#introduction-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-151"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#conversations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.1: Conversations")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-152"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#cesuo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.2: Cesuo")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-153"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#a-circus-came-to-town",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.3: A Circus Came to Town")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-154"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#no-sex-please-were",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.4: No Sex, Please, We’re…")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-155"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#summer-animals",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.5: Summer Animals")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-156"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#australian-experience",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.6: Australian Experience")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-157"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#city-changes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.7: City Changes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-158"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#visitors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.8: Visitors")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-159"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#accidents",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.9: Accidents")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-160"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#weevils",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.10: Weevils")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-161"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#exercise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.11: Exercise")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-162"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-12-farewells",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Farewells")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-163"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#introduction-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-164"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#farewells-to-greg",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.1: Farewells to Greg")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-167"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#farewells-to-the-americans",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.2: Farewells to the\n                            Americans")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-168"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#graduations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.3: Graduations")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-171"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#my-farewells",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.4: My Farewells")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-172"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0